import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@pdfking/components"
import { DarkModeSwitch, LanguageSwitch, SIDEBAR_ACTIVE_CLASS, ViewerRail } from "@pdfking/pdfview"
import { AppWindowIcon, BookOpenIcon, HouseIcon, InfoIcon } from "lucide-react"
import type { ComponentChildren } from "preact"

import { Link } from "../router"

// The site's own pages, the viewer among them.
const PAGES = [
  { name: "home", label: "Home", icon: HouseIcon },
  { name: "docs", label: "Docs", icon: BookOpenIcon },
  { name: "about", label: "About", icon: InfoIcon },
  { name: "viewer", label: "PDF View", icon: AppWindowIcon },
] as const

export type SitePage = (typeof PAGES)[number]["name"]

/**
 * The site's rail: its pages on top, lit on `active`, then whatever `top`
 * adds (the viewer's panels); `bottom` (the viewer's debug views) above the
 * language and dark mode switches.
 */
export const SiteRail = ({
  active,
  bottom,
  top,
}: {
  active: SitePage
  bottom: ComponentChildren
  top: ComponentChildren
}) => (
  <ViewerRail
    bottom={
      <>
        {bottom}
        {/* The rail is vertical and flush to the left edge — tooltips go
            beside it, not under it. */}
        <div className="flex flex-col items-center gap-1 border-t pt-2">
          <LanguageSwitch side="right" />
          <DarkModeSwitch side="right" />
        </div>
      </>
    }
    top={
      <>
        <SidebarMenu className="mb-2 border-b pb-2">
          {PAGES.map(page => (
            <SidebarMenuItem key={page.name}>
              <SidebarMenuButton
                asChild
                className={SIDEBAR_ACTIVE_CLASS}
                isActive={page.name === active}
                tooltip={page.label}
              >
                <Link name={page.name}>
                  <page.icon />
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
        {top}
      </>
    }
  />
)
